import { useTranslation } from '@frontend/i18n';
import type { GetWeavePopNotificationByType, NotificationActions } from '@frontend/types';
import { BaseNotificationComponentProps, BaseNotificationInner, BaseNotificationOuter } from './base';
import { DefaultNotificationBody } from './defaults/default-notification';

type Props = BaseNotificationComponentProps<GetWeavePopNotificationByType<'task-center'>>;

export const TaskCenterNotificationComponent = ({ isHistorical, emit, notification, ...rest }: Props) => {
  const { t } = useTranslation();
  const actions: NotificationActions = notification.payload.hasActionView
    ? [
        {
          label: t('View'),
          action: () => {
            emit({ action: 'view', payload: undefined }, notification);
          },
        },
      ]
    : [];

  const title = notification.payload.notificationType ?? t('Task Center');

  return (
    <BaseNotificationOuter
      actions={actions}
      notification={notification}
      emit={emit}
      isHistorical={isHistorical}
      {...rest}
    >
      <BaseNotificationInner
        onClose={() => emit({ action: 'ignore', payload: undefined }, notification)}
        actions={actions}
        title={title}
        body={
          <DefaultNotificationBody name={notification.payload.title ?? ''} body={notification.payload.body ?? ''} />
        }
        location={notification.location}
        timestamp={notification.timestamp}
        id={notification.id}
        notificationType={notification.type}
        {...rest}
      />
    </BaseNotificationOuter>
  );
};
